import { render } from "./Gold.vue?vue&type=template&id=57b682e4"
import script from "./Gold.vue?vue&type=script&lang=js"
export * from "./Gold.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Gold.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57b682e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57b682e4', __exports__)) {
    api.reload('57b682e4', __exports__)
  }
  
  module.hot.accept("./Gold.vue?vue&type=template&id=57b682e4", () => {
    api.rerender('57b682e4', render)
  })

}


export default __exports__